import baseHttp from './baseHttp';

export const loginRestaurant = (email, password) =>
  baseHttp.post(
    '/user/mobile/login/restaurant',
    { email, password },
    { headers: { 'X-Client-Type': 'store-dashboard' } }
  ).then((r) => r.data);

export const getMyInfo = () =>
  baseHttp.get('/api/v1/web/auth/me').then((r) => r.data);

export const logoutWebSession = () =>
  baseHttp.post('/api/v1/web/auth/logout').then((r) => r.data);

export const getRestaurant = (restaurantId) =>
  baseHttp.get(`/api/v1/restaurants/${restaurantId}`).then((r) => r.data);

export const toggleRestaurantActive = (restaurantId, active) =>
  baseHttp
    .post(`/api/v1/restaurants/${restaurantId}/active`, { active })
    .then((r) => r.data);
